// @flow
import WebComponent from '../webComponents/WebComponent';

export default class AnchorsList extends WebComponent {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	didMount() {
		const {
			childSelector,
			clickSelector,
			activeClass,
		} = this.props;

		this.activeClass = activeClass;
		this.targetElements = this.element.querySelectorAll(childSelector);
		this.clickElements = this.element.querySelectorAll(clickSelector);
		this.activeElement = this.element.querySelector(childSelector + '.' + activeClass);

		if ((!this.activeElement) && (this.targetElements)) {
			this.activeElement = this.targetElements[0];
			this.activeElement.classList.add(activeClass);
		}

		Array.from(this.clickElements).forEach(link => {
			link.addEventListener('click', this.handleClick);
		});
	}

	handleClick(e) {
		Array.from(this.targetElements).forEach(target => {
			target.classList.remove(this.activeClass);
		});
		e.target.parentNode.classList.add(this.activeClass);
	}
}

AnchorsList.defaultProps = {
	childSelector: 'li',
	clickSelector: 'li a',
	activeClass: 'active',
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/AnchorsList.js